import { render, staticRenderFns } from "./tablePriceDisplay.vue?vue&type=template&id=0dbb90bc&scoped=true"
import script from "./tablePriceDisplay.vue?vue&type=script&lang=js"
export * from "./tablePriceDisplay.vue?vue&type=script&lang=js"
import style0 from "./tablePriceDisplay.vue?vue&type=style&index=0&id=0dbb90bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbb90bc",
  null
  
)

export default component.exports